import {Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, Input} from '@angular/core';
import {CalendarHoliday} from '../object-holiday.model';
import {FormBuilder, FormGroup} from '@angular/forms';

/**
 * Компонент для отображения единичного блока из таблицы CalendarHoliday
 */
@Component({
    selector: 'app-calendar-scheduler-holiday',
    templateUrl: './calendar-scheduler-holiday.component.html',
    styleUrls: ['./calendar-scheduler-holiday.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CalendarSchedulerHolidayComponent implements OnInit {
  @Input() calendarHoliday: CalendarHoliday;
  @Input() id: number;
  @Input() showCustomTime = false;
  @Output() addCalendarHoliday = new EventEmitter();
  @Output() removeCalendarHoliday = new EventEmitter();
  @Output() changeCalendarHoliday = new EventEmitter();

  public configForm: FormGroup;

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.createForm();
    this.configForm.valueChanges.subscribe((values) => {
      this.calendarHoliday.weekday = parseInt(values.weekday, 10);
      this.calendarHoliday.date = values.date.getTime();
    });
  }

  afterPickerClosed() {
    this.changeCalendarHoliday.emit();
  }
  /**
   * Создает форму для заполнения времени и даты
   */
  createForm() {
    const formModel = {
      date: new Date(this.calendarHoliday.date),
      weekday: this.calendarHoliday.weekday,
    };

    this.configForm = this.formBuilder.group(formModel as { [p: string]: any });
  }

  public fromDateChanged(event) {
    if (event && event instanceof Date) {
      this.calendarHoliday.date = event.getTime();
      this.changeCalendarHoliday.emit(this.id);
    }
  }
}
